import { ACCOUNT_LENGTH_FIRST_PART } from './constants';

export const formatAccountNumber = (value: string) => {
  const newValue = value.replace(/\D/g, '');

  return newValue.length > ACCOUNT_LENGTH_FIRST_PART
    ? `${newValue.slice(0, ACCOUNT_LENGTH_FIRST_PART)}-${newValue.slice(ACCOUNT_LENGTH_FIRST_PART)}`
    : newValue;
};
